import React, { useState, useEffect, useContext } from 'react';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { MENU_PLP_CONSTANT } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import SampleArrowNext from 'organisms/OffersAndPromotions/Presentation/SampleArrowNext';
import SampleArrowPrev from 'organisms/OffersAndPromotions/Presentation/SampleArrowPrev';
import { useSelector, useDispatch } from 'react-redux';
import { UserOrderContext } from 'context/context';
import {
  addItemToFavouriteAction,
  addItemToUnFavouriteAction,
  fetchItemDetailsAction,
} from '@kfc-global/react-shared/redux/Actions/MenuAction';
import {
  addItemToCartAction,
  showCustomizationModalAction,
  setUserLastActiveTime,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import {
  getPrice,
  getFullImagePath,
  isMobileDevice,
  getValueOrDefaultObject,
  getAndCheck,
  getValueOrnull,
  getValueOrDefaultZero,
  getToOpenMiniPDPModal,
  displayBucketIcon,
  getPriceWithExtractingJsonHelper,
} from 'common/utilities/utils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { shouldDisableButton } from 'organisms/MenusPLP/MenusPlpUtilities/MenusPlpUtils';
import { CAROUSEL_RESPONSIVE_SETTINGS } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { FavouriteInActiveBlack, heartIcon_active_red, Non_veg_dot_Icon } = IMAGE_PATH;

const { ADD_TO_CART_CLICK, MINI_PDP_DATA, FROMFLAGPLP, EDIT_CLICKED } = START_ORDER_CONSTANTS;
const { RECOMENDATIONS } = CART_PAGE_CONSTANTS;
const { SLIDES_TO_SCROLL, SLIDES_TO_SHOW, ADD_TO_CART } = RECOMENDATIONS;
const { CARD_TYPE } = MENU_PLP_CONSTANT;
const { RESET_MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;

export const settingsRecomendation = (onNext, onPrev, updateRange, updateCurrent) => {
  return {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    nextArrow: <SampleArrowNext clickNextCard={onNext} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrev} />,
    beforeChange: (current, next) => updateRange(next),
    afterChange: (current, prev) => updateCurrent(current),
    variableWidth: true,
    responsive: CAROUSEL_RESPONSIVE_SETTINGS,
  };
};

export const classesBy = (CARDTYPE, CHECK) => {
  let classes;
  let btnType = 'button activeBtn';
  btnType += CHECK ? ' blackButton' : ' redButton';
  switch (CARDTYPE) {
    case CARD_TYPE.LARGE:
      classes = 'menu-cart-button';
      break;
    case CARD_TYPE.MEDIUM:
      classes = 'medium-menu-cart-button';
      break;
    case CARD_TYPE.SMALL:
      classes = 'small-menu-cart-button';
      break;
    case CARD_TYPE.CAROUSAL:
      classes = 'carousal-menu-cart-button';
      break;
    default:
      classes = '';
      break;
  }
  return `${btnType} ${classes}`;
};

export const menuCardBtnText = data => {
  let btnText = translateWithI18Next(ADD_TO_CART);
  let className = '';
  let enabled = true;

  if (data?.isStoreNone) {
    btnText = 'Store Closed';
    className = 'no-store-selected';
    enabled = false;
  } else if (data?.isStoreClosed) {
    btnText = 'Store Closed';
    className = 'store-closed';
    enabled = false;
  }

  return {
    btnText,
    className,
    enabled,
  };
};

export const classEnableAddToCart = (enableAddToCartButton, cardType, checkLoading, storeClosedData) => {
  if (enableAddToCartButton) {
    return `${classesBy(cardType, checkLoading)} ${menuCardBtnText(storeClosedData).className}`;
  } else {
    return 'button btn-black medium-menu-cart-button';
  }
};

export const AddToFav = ({ saveProduct, favItems, item }) => {
  return (
    <ImageComponent
      srcFile={
        getAndCheck(
          Array.isArray(favItems),
          favItems?.find(el => el?.id === item?.id),
        )
          ? heartIcon_active_red
          : FavouriteInActiveBlack
      }
      alt={'add to favourite'}
      className='recomendation-item-save'
      onClick={saveProduct}
      data-testid='add-to-fav-image'
    />
  );
};

const RecomendationItem = ({ storeClosedData, recommendedProducts }) => {
  // Removing hidden products for the recommendations list
  const noHiddens = recommendedProducts?.filter(i => !i.isHidden);
  return (
    Boolean(noHiddens?.length) && (
      <div className='cart-recomendations-container'>
        <span className='cart-recomendations-title'>
          {translateWithI18Next(CART_PAGE_CONSTANTS.EMPTY_CART.SUGGESTION_TEXT)}
        </span>
        <RecomendationList recommendRules={noHiddens} storeClosedData={storeClosedData} />
      </div>
    )
  );
};

const RecomendationCard = ({ item, tenantData, storeClosedData }) => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [enableAddToCartButton, setEnableAddToCardButton] = useState(true);
  const [activeId, setActiveId] = useState(null);
  const [selectedCat, setSelectedCat] = useState('');
  const [itemCount] = useState(0);
  const cardType = 'medium';
  const dispatch = useDispatch();
  let storeInfo = getValueOrDefaultObject(JSON.parse(localStorage.getItem('currentStoreInfo')));
  const userParams = useSelector(data => data.appStateReducer?.userStatus);
  const cartReducer = useSelector(data => data.cartReducer);
  const { isAddItemLoading = false } = getValueOrDefaultObject(cartReducer);
  const customizable = item.customizable;
  const favouriteItems = useSelector(data => getValueOrnull(data.profileReducer?.favouriteItems));
  const customerinfo = useSelector(data => data.profileReducer?.basic);
  const customerId = customerinfo?.id;
  const { flatResponse: { productMapById = {}, categoryMapById = {} } = {} } =
    useSelector(({ menuReducer }) => menuReducer) ?? {};
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const addItemToFavourite = (tenant_id, data, customer_id) => {
    dispatch(
      addItemToFavouriteAction(
        {
          tenant_id,
          customer_id,
        },
        data,
      ),
    );
  };

  const removeItemFromFavourite = (tenant_id, customer_id, item_id) => {
    dispatch(
      addItemToUnFavouriteAction({
        tenant_id,
        customer_id,
        item_id,
      }),
    );
  };

  const addItemToFavouriteCart = async (tntId, itemDetails, itemAvailability, custInfo) => {
    const priceVal = getValueOrDefaultZero(itemAvailability[0]?.price);
    const payload = {
      mdmId: itemDetails.mdmId,
      id: itemDetails.id,
      name: itemDetails.name,
      imageName: itemDetails.imageName,
      description: itemDetails.longDescription,
      quantity: 1,
      isCustomized: itemDetails.customizable,
      price: priceVal / tenantData?.currencyConversionFactor,
      additionalProperties: itemDetails.additionalProperties,
    };
    await addItemToFavourite(tntId, payload, custInfo);
    await dispatch(
      showCustomizationModalAction({
        showProductListingModal: false,
        categorySelected: '',
      }),
    );
  };

  const unFavouriteAnItem = (tntId, custId, itm) => {
    removeItemFromFavourite(tntId, custId, itm.id);
  };

  const favouriteButtonClickHandler = () => {
    getAndCheck(
      Array.isArray(favouriteItems),
      favouriteItems?.find(el => el?.id === item?.id),
    )
      ? unFavouriteAnItem(tenantId, customerId, item)
      : addItemToFavouriteCart(tenantId, item, availability, customerId);
  };

  useEffect(() => {
    setEnableAddToCardButton(true);
  }, [itemCount]);

  const clickHandler = (categoryItem, customizableItem, catDetails, productDetailsData) => {
    const { id, itemCounts, product } = productDetailsData;
    const { catId, catName, catUrl } = catDetails;
    categoryItem && categoryItem.stopPropagation();
    setActiveId(id);
    if (userParams.localized) {
      if (customizableItem) {
        setSelectedCat(catId);
        userOrderStateDispatch({
          type: MINI_PDP_DATA,
          value: { id: id, flag: FROMFLAGPLP, foodLineId: '' },
        });
        //Customization Modal
        userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
        userOrderStateDispatch({
          type: EDIT_CLICKED,
          value: { cartEditClicked: true },
        });
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantData.tenantId,
            catalogName: storeInfo?.summary?.menu?.catalogs[0],
            itemId: id,
          }),
        );
      } else if (itemCounts === 0) {
        dispatch(
          addItemToCartAction(
            {
              params: {
                basketId: cartReducer?.cartData?.id,
              },
              tenantId: tenantData.tenantId,
            },
            [
              {
                Id: id,
                categoryId: catId,
                quantity: itemCounts + 1,
                modGrps: [],
                categoryName: catName,
                categoryUrl: catUrl,
              },
            ],
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
      }
    } else {
      userOrderStateDispatch({
        type: ADD_TO_CART_CLICK,
        value: {
          addToCart: true,
          productItemId: id,
          categoryId: categoryId,
          oldProduct: product,
          customizable: customizableItem,
          catalogs: storeInfo?.summary?.menu?.catalogs[0],
          fromPdpPage: false,
        },
      });
    }
  };

  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  useEffect(() => {
    //to set flag in cartReducer
    let toOpen = getToOpenMiniPDPModal(currentItemDetails, userOrderState);
    if (toOpen) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: selectedCat,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails]);

  const cardId = item?.id;
  const itemId = cardId?.split('_')[0] || '';
  const { categoryId: productCatId = '' } = productMapById?.[itemId] ?? {};
  const { id: categoryId = '', name: categoryName = '', url: categoryUrl = '' } = categoryMapById?.[productCatId] ?? {};
  const checkLoading = isAddItemLoading && activeId === cardId;

  const {
    currencyConversionFactor = 1,
    currencySymbol = '',
    tenantId = '',
    componentOptions: { web: { global: { showPriceWithTax = false } = {} } = {} } = {},
  } = tenantData;
  const { name = '', availability, shortDescription, imageName, additionalProperties } = item;
  const desc = shortDescription ? shortDescription[0].value : '';
  /**
   * RENDEV-10995 show the price without tax
   */
  const price = getPriceWithExtractingJsonHelper(
    availability[0],
    additionalProperties,
    currencyConversionFactor,
    showPriceWithTax,
  );
  const categoryDetails = {
    catId: categoryId,
    catName: categoryName,
    catUrl: categoryUrl,
  };
  const renderVegNonVeg = () => {
    return (
      <>
        <div className='recomendation-item-header'>
          <span className='recomendation-item-name'>{name}</span>
        </div>
        <span className='recomendation-item-desc'>{desc}</span>
        <div className='recomendation-item-serving-conatiner'>
          <span className='recomendation-item-price'>
            {currencySymbol}
            {price}
          </span>
          <span className='recomendation-item-serving'>Non veg • Serves 4</span>
        </div>
      </>
    );
  };

  const productDetails = {
    id: cardId,
    itemCounts: itemCount,
    product: {
      productName: item.dname,
      productImage: imageName,
      productPrice: getPrice(availability[0], tenantData?.currencyConversionFactor),
    },
  };
  return (
    <div className='recomendation-item-container'>
      <ImageComponent
        data-testid='recomendation-item-img'
        className='recomendation-item-img'
        defaultPath={getFullImagePath(null, tenantData, true)}
        srcFile={getFullImagePath(imageName, tenantData)}
      />
      {!isMobile ? (
        <>
          <div className='recomendation-item-header'>
            <span className='recomendation-item-name'>{name}</span>
            <span className='recomendation-item-price'>
              {currencySymbol}
              {price}
            </span>
          </div>
          <div className='recomendation-item-serving-conatiner'>
            <img className='recomendation-item-serving-type' src={Non_veg_dot_Icon} alt='' />
            <span className='recomendation-item-serving'>Non veg • Serves 4</span>
          </div>
          <span className='recomendation-item-desc'>{desc}</span>
        </>
      ) : (
        renderVegNonVeg()
      )}

      <div className='recomendation-item-actions'>
        <ButtonComp
          tabIndex='1'
          className={classEnableAddToCart(enableAddToCartButton, cardType, checkLoading, storeClosedData)}
          data-testid={`add-to-cart-${cardId}`}
          disabled={shouldDisableButton(storeClosedData)}
          onClickHandler={categoryItem => {
            if (menuCardBtnText(storeClosedData).enabled) {
              clickHandler(categoryItem, customizable, categoryDetails, productDetails);
            }
            categoryItem.preventDefault();
            categoryItem.stopPropagation();
          }}
          aria-label={menuCardBtnText(storeClosedData).btnText}
        >
          {menuCardBtnText(storeClosedData).btnText}
          {displayBucketIcon(storeClosedData.isStoreClosed)}
        </ButtonComp>
        {userParams?.loggedin && (
          <AddToFav saveProduct={favouriteButtonClickHandler} favItems={favouriteItems} item={item} />
        )}
      </div>
    </div>
  );
};

const RecomendationList = ({ recommendRules, storeClosedData }) => {
  recommendRules = recommendRules?.filter(rule => rule.name !== undefined);
  const tenantData = useSelector(state => state.tenantReducer);
  const [currentSlide, updateCurrentSlide] = useState(0);
  const [rangeValue, updateRangeValue] = useState(0);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);
  const carousal = React.useRef(null);

  const onNextCard = () => {
    if (currentSlide < recommendRules.length - 1) {
      let updatedCurrentSlide = 0;
      if (currentSlide + SLIDES_TO_SCROLL > recommendRules.length - SLIDES_TO_SHOW - 1) {
        updatedCurrentSlide = recommendRules.length - SLIDES_TO_SHOW;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
    return true;
  };

  /* OnClicking Previous Arrow Button */
  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
    return true;
  };

  const onUpdateRange = e => {
    updateRangeValue(e.target.value);
    carousal.current.slickGoTo(e.target.value);
  };

  return (
    <div className='cart-recomendations-list-container-root'>
      <div className='cart-recomendations-list-container'>
        {recommendRules.length && (
          <CarauselComp
            settings={settingsRecomendation(onNextCard, onPrevCard, updateRangeValue, updateCurrentSlide)}
            carousalRef={carousal}
          >
            {recommendRules.map(item => {
              return <RecomendationCard item={item} tenantData={tenantData} storeClosedData={storeClosedData} />;
            })}
          </CarauselComp>
        )}
      </div>
      {!isMobile && (
        <div className='cart-recomendations-slideContainer'>
          <input
            className='cart-recomendations-slider'
            type='range'
            min='0'
            max={recommendRules.length - SLIDES_TO_SHOW}
            value={rangeValue}
            id='myRange'
            onChange={onUpdateRange}
          />
        </div>
      )}
    </div>
  );
};

export default RecomendationItem;
